import React from "react";
import { Grid } from "@mui/material";

import "./styles.scss";

export default function FormContainer({
  hasAdditionalTopMargin,
  children,
}: {
  hasAdditionalTopMargin?: boolean;
  children: React.ReactNode;
}): React.JSX.Element {
  const className = hasAdditionalTopMargin ? "scd-section-pusher-lg" : "";
  return (
    <Grid container size={{ xs: 12 }} className={className}>
      {children}
    </Grid>
  );
}
